import { useQuery } from '@tanstack/react-query';
import { getWorkflowInfoMetrics } from '@/services/composer-dashboard/get-workflow-info-metrics';
import { WorkflowInfoMetricsResponse } from '@/types/composer-dashboard';
import { useOrgStore } from '@/stores/org-store';

export const useGetWorkflowInfoMetrics = (labelIds?: string[]) => {
  const { currentOrg } = useOrgStore();
  const orgId = currentOrg?.orgid;

  return useQuery<WorkflowInfoMetricsResponse, Error>({
    queryKey: ['composer-workflow-info-metrics', orgId, labelIds ?? []],
    queryFn: () => getWorkflowInfoMetrics(orgId!, labelIds),
    enabled: !!orgId,
    retry: 1,
    staleTime: 60000,
  });
};
